// import { Pagination } from "react-bootstrap";
import CachedIcon from "mdi-react/CachedIcon";
import { useQuery } from "react-query";
import currency from "currency.js";
import {
  endOfMonth,
  endOfYear,
  format,
  parse,
  startOfMonth,
  startOfYear,
  subYears,
} from "date-fns";
import { useEffect, useState, useRef, useMemo } from "react";
import queryString from "query-string";
import { CSVLink } from "react-csv";

import "./../../assets/scss/reports/cashbook.scss";
import useDebounce, {
  useCurrencies,
  useQueryParams,
  useScrollTop,
} from "../../utils/hooks";
import { useAuth } from "../../hooks/useAuth";
import ModalLoader from "../utils/ModalLoader";
import RsDateRangePicker from "../utils/RsDateRangePicker";
import { ExcelIcon, PDFIcon, ExportIcon } from "../Icons";
import { useDownloadExcel } from "../../hooks/useDownloadExcel";
import { Link } from "react-router-dom";
import { IsPrivileged } from "../DisplayChildElement";
import { backendApis } from "../../config";
import { Dropdown, Form, Table } from "react-bootstrap";
import { isEmpty, isNumber } from "lodash";
import Select from "react-select";
import IncorrectAccountsData from "../SystemMessages/IncorrectAccountsData";
import PeriodFilter from "./MultipPeriodSelector";
import {
  getDefaultThreeYearRange,
  getOrdinalSuffix,
  MODE_OPTIONS,
} from "../Fleet/utils";
import DatePicker from "react-datepicker";
import DateTime from "react-datetime";
import YearOnYearMonthOnMonthSelector from "./YearOnYearMonthOnMonthSelector";
import moment from "moment";

const months = [
  {
    value: "All",
    label: "All",
  },
  {
    value: "Date Range",
    label: "Date Range",
  },
  {
    value: "01-01",
    label: "January",
  },
  {
    value: "02-01",
    label: "February",
  },
  {
    value: "03-01",
    label: "March",
  },
  {
    value: "04-01",
    label: "April",
  },
  {
    value: "05-01",
    label: "May",
  },
  {
    value: "05-01",
    label: "June",
  },
  {
    value: "07-01",
    label: "July",
  },
  {
    value: "08-01",
    label: "August",
  },
  {
    value: "09-01",
    label: "September",
  },
  {
    value: "10-01",
    label: "October",
  },
  {
    value: "11-01",
    label: "November",
  },
  {
    value: "12-01",
    label: "December",
  },
];

const monthNames = [
  "Jan",
  "Feb",
  "Mar",
  "Apr",
  "May",
  "Jun",
  "Jul",
  "Aug",
  "Sep",
  "Oct",
  "Nov",
  "Dec",
];
const quarterNames = [
  "",
  "1st Quarter",
  "2nd Quarter",
  "3rd Quarter",
  "4th Quarter",
];

// month is 0-indexed (confirmed against your sample's start dates)
const getColumnLabel = (period) => {
  let week = "";
  if (period?.week) {
    const getWeekLabel = (week) => `${week}${getOrdinalSuffix(week)} Week`;

    week = getWeekLabel(period.week);
  }

  return `${monthNames[(period?.month)] ||
    period?.year ||
    quarterNames[(period?.quarter)] ||
    week ||
    ""} `;
};

// Union + de-dupe, preserving first-seen order
const getUniqueLabels = (listOfLists) => {
  const seen = new Set();
  const result = [];
  listOfLists.forEach((list) => {
    list.forEach((label) => {
      if (label && !seen.has(label)) {
        seen.add(label);
        result.push(label);
      }
    });
  });
  return result;
};

function getMonthDateRange({ year, month }) {
  if (!year || !month || month === "All" || month === "Date Range") {
    return null; // handle these cases separately in your filter logic
  }

  const [monthNum] = month.split("-"); // "01-01" -> "01"
  const baseDate = new Date(Number(year), Number(monthNum) - 1, 1);

  return {
    startDate: format(startOfMonth(baseDate), "yyyy-MM-dd"),
    endDate: format(endOfMonth(baseDate), "yyyy-MM-dd"),
  };
}

function IncomeStateMentWithRange() {
  useScrollTop();
  const initialFilterParams = {
    year: new Date().getFullYear(),
    month: "All",
    mode: "",
    // startDate: "",
    // endDate: "",
  };

  const {
    deploymentCurrencies: currenciesOptions,
    prevailingCurrency,
    getCurrencySymbol,
  } = useCurrencies();
  const [disableDate, setDisableDate] = useState(null);
  const [excelData, setExcelData] = useState([]);
  const CSVLinkRef = useRef(null);
  const [dateRangeMode, setDateRangeMode] = useState("");
  const tableRef = useRef(null);
  const [csvData, setCsvData] = useState([]);

  // fetch excel hook
  const [isfetchingExcel, fetchExcelData] = useDownloadExcel(
    excelData,
    CSVLinkRef,
  );

  const { backendUrl, brachData } = useAuth();

  const [queryParams, setQueryParams] = useQueryParams({
    ...initialFilterParams,
    currency: "",
    convertCurrency: prevailingCurrency,
  });

  const [filterParams, setFilterParams] = useState({
    ...initialFilterParams,
    ...queryParams,
  });

  const debouncedFilterParams = useDebounce(filterParams, 500);
  useEffect(() => {
    setQueryParams({
      ...queryParams,
      ...debouncedFilterParams,
    });
  }, [debouncedFilterParams]);

  useEffect(() => {
    filterParams?.startDate && filterParams?.endDate
      ? setDisableDate(false)
      : setDisableDate(true);
  }, [filterParams?.startDate, filterParams?.endDate]);

  // const fetchCustomerLedgers = async queryParams => {
  //   let data = {};

  //   if (filterParams.consolidate) {
  //     const allDatas = await Promise.all(
  //       backendApis.map(endPoints => {
  //         return new Promise(async (resolve, reject) => {
  //           try {
  //             let response = await fetch(
  //               `${endPoints.url
  //               }/api/reports/income-statement-2?&${queryString.stringify(
  //                 queryParams
  //               )}`,
  //               {
  //                 method: "GET",
  //                 headers: {
  //                   Accept: "Application/json",
  //                   "Content-Type": "Application/json",
  //                 },
  //                 credentials: "include",
  //               }
  //             );

  //             if (!response.ok) {
  //               response = await response.json();
  //               throw new Error(response.message);
  //             }

  //             const { data } = await response.json();
  //             resolve(data);
  //           } catch (error) {
  //             console.log(error);
  //             reject(error);
  //           }
  //         });
  //       })
  //     );

  //     data = {
  //       accountIdsForReport: {},
  //       administrativeExpenses: {},
  //     };

  //     for (let branchData of allDatas) {
  //       for (let [key, value] of Object.entries(branchData)) {
  //         if (key == "accountIdsForReport") {
  //           for (let accId in value) {
  //             data[key][accId] = branchData[key]?.[accId];
  //           }
  //         } else if (key == "administrativeExpenses") {
  //           for (let accId in value) {
  //             data[key][accId] = currency(branchData[key]?.[accId]).add(
  //               data[key][accId]
  //             ).value;
  //           }
  //         } else {
  //           data[key] = isNumber(value)
  //             ? currency(data[key]).add(value).value
  //             : value;
  //         }
  //       }
  //     }
  //   } else {
  //     let response = await fetch(
  //       `${backendUrl}/api/reports/income-statement-2?&${queryString.stringify(
  //         queryParams
  //       )}`,
  //       {
  //         method: "GET",
  //         headers: {
  //           Accept: "Application/json",
  //           "Content-Type": "Application/json",
  //         },
  //         credentials: "include",
  //       }
  //     );

  //     if (!response.ok) {
  //       response = await response.json();
  //       throw new Error(response.message);
  //     }

  //     let responseData = await response.json();
  //     data = responseData.data;
  //   }
  //   console.log("I have this here: " , data)

  //   // ===================================================
  //   data.grossProfit = currency(data.salesRevenue, {
  //     symbol: "",
  //   })
  //     .add(data.serviceFeeIncome)
  //     .add(data.otherIncome)
  //     .subtract(data.costOfgoodsold)
  //     .format();

  //   data.administrativeExpensesTotal = currency(
  //     Object.entries(data.administrativeExpenses).reduce(
  //       (a, c) => a + parseFloat(c[1]),
  //       0
  //     ),
  //     {
  //       symbol: "",
  //     }
  //   ).format();

  //   data.netIncome = currency(data.grossProfit, {
  //     symbol: "",
  //   })
  //     .subtract(data.administrativeExpensesTotal)
  //     .format();

  //   return data;
  // };

  const fetchCustomerLedgers = async (queryParams) => {
    const computeFields = (data) => {
      data.grossProfit = currency(data.salesRevenue, { symbol: "" })
        .add(data.serviceFeeIncome)
        .add(data.otherIncome)
        .subtract(data.costOfgoodsold)
        .format();

      data.administrativeExpensesTotal = currency(
        Object.entries(data.administrativeExpenses).reduce(
          (a, c) => a + parseFloat(c[1]),
          0,
        ),
        { symbol: "" },
      ).format();

      data.netIncome = currency(data.grossProfit, { symbol: "" })
        .subtract(data.administrativeExpensesTotal)
        .format();

      return data;
    };

    if (filterParams.consolidate) {
      // Fetch all branches — each returns an array of period objects
      const allBranchResults = await Promise.all(
        backendApis.map(
          (endPoints) =>
            new Promise(async (resolve, reject) => {
              try {
                let response = await fetch(
                  `${
                    endPoints.url
                  }/api/reports/income-statement-2?&${queryString.stringify(
                    queryParams,
                  )}`,
                  {
                    method: "GET",
                    headers: {
                      Accept: "Application/json",
                      "Content-Type": "Application/json",
                    },
                    credentials: "include",
                  },
                );

                if (!response.ok) {
                  response = await response.json();
                  throw new Error(response.message);
                }

                const { data } = await response.json();
                resolve(data); // data is now an array of period objects
              } catch (error) {
                console.log(error);
                reject(error);
              }
            }),
        ),
      );

      // allBranchResults = [ [p1, p2, p3, p4], [p1, p2, p3, p4], ... ] — one array per branch
      // Use the first branch's periods as the base structure, then merge the rest into it
      const basePeriods = allBranchResults[0];

      const mergedPeriods = basePeriods.map((basePeriod, periodIndex) => {
        // Start with a clean accumulator for this period
        const merged = {
          accountIdsForReport: {},
          administrativeExpenses: {},
        };

        // Loop through each branch's data for this period index
        for (const branchResult of allBranchResults) {
          const branchPeriod = branchResult[periodIndex];
          if (!branchPeriod) continue;

          const branchData = branchPeriod.data;

          for (const [key, value] of Object.entries(branchData)) {
            if (key === "accountIdsForReport") {
              for (const accId in value) {
                merged[key][accId] = branchData[key]?.[accId];
              }
            } else if (key === "administrativeExpenses") {
              for (const accId in value) {
                merged[key][accId] = currency(branchData[key]?.[accId]).add(
                  merged[key][accId],
                ).value;
              }
            } else {
              merged[key] = isNumber(value)
                ? currency(merged[key]).add(value).value
                : value;
            }
          }
        }

        return {
          mode: basePeriod.mode,
          year: basePeriod.year,
          data: computeFields(merged),
        };
      });

      return mergedPeriods;
    } else {
      // Non-consolidated: single branch returns array of periods
      let response = await fetch(
        `${backendUrl}/api/reports/income-statement-2?&${queryString.stringify(
          queryParams,
        )}`,
        {
          method: "GET",
          headers: {
            Accept: "Application/json",
            "Content-Type": "Application/json",
          },
          credentials: "include",
        },
      );

      if (!response.ok) {
        response = await response.json();
        throw new Error(response.message);
      }

      const { data: periodsArray } = await response.json();

      // Apply computeFields to each period's data
      return periodsArray.map((period) => ({
        ...period,
        data: computeFields(period.data),
      }));
    }
  };
  const {
    data = {
      count: 0,
      customerLedgers: [],
    },
    refetch,
    isFetching,
    // isSuccess,
  } = useQuery(
    ["INCOME_STATEMENT", queryParams],
    () => fetchCustomerLedgers(queryParams),
    {
      keepPreviousData: true,
    },
  );

  const periods = useMemo(() => {
    if (data && data?.length) {
      return data;
    }
    return [];
  }, [data]); // data is now the array from the API

  const monthsOptions = useMemo(() => {
    if (filterParams.month === "All") {
      return MODE_OPTIONS;
    }
    if (filterParams?.month) {
      return [
        { label: "None", value: "" },
        ...MODE_OPTIONS.filter((month) => month.value === "wow"),
      ];
    }

    return MODE_OPTIONS;
  }, [filterParams?.month]);

  const columnCount = periods.length;

  const incomeLabels = useMemo(
    () =>
      getUniqueLabels(
        periods.map((p) =>
          (p.data?.incomeJournal ?? []).map((el) => el.DetailType),
        ),
      ),
    [periods],
  );
  const costOfSalesLabels = useMemo(
    () =>
      getUniqueLabels(
        periods.map((p) =>
          (p.data?.costOfSalesJournal ?? []).map((el) => el.DetailType),
        ),
      ),
    [periods],
  );
  const expenseLabels = useMemo(
    () =>
      getUniqueLabels(
        periods.map((p) => Object.keys(p.data?.administrativeExpenses ?? {})),
      ),
    [periods],
  );

  // Per-period fast lookup, so each row doesn't re-scan every period's array
  const periodLookups = useMemo(
    () =>
      periods.map((p) => {
        const incomeMap = {};
        (p.data?.incomeJournal ?? []).forEach(
          (el) => (incomeMap[el.DetailType] = el),
        );
        const costOfSalesMap = {};
        (p.data?.costOfSalesJournal ?? []).forEach(
          (el) => (costOfSalesMap[el.DetailType] = el),
        );
        return {
          period: p,
          incomeMap,
          costOfSalesMap,
          expenses: p.data?.administrativeExpenses ?? {},
        };
      }),
    [periods],
  );

  const gridTemplate = `minmax(220px, 2fr) repeat(${columnCount}, minmax(120px, 1fr))`;

  // download excel function
  const { limit, page, ...rest } = queryParams;
  const onDownloadExcelData = async () => {
    // NO need to get from api, there is no pagination
    let exData = {
      data,
    }; /* await fetchExcelData(
      `${backendUrl}/api/reports/income-statement?${queryString.stringify(
        rest
      )}`,
      "GET"
    );  */

    const {
      company,
      salesRevenue,
      otherIncome,
      costOfgoodsold,
      administrativeExpenses,
      serviceFeeIncome,
    } = exData.data;

    const grossProfit = currency(salesRevenue, {
      symbol: "",
    })
      .add(serviceFeeIncome)
      .add(otherIncome)
      .subtract(costOfgoodsold)
      .format();

    const administrativeExpensesTotal = currency(
      Object.entries(administrativeExpenses).reduce(
        (a, c) => a + parseFloat(c[1]),
        0,
      ),
      {
        symbol: "",
      },
    ).format();

    const netIncome = currency(grossProfit, {
      symbol: "",
    })
      .subtract(administrativeExpensesTotal)
      .format();

    const admins = Object.entries(administrativeExpenses).map((a, i) => [
      a[0],
      a[1],
    ]);

    const date =
      rest.startDate && rest.endDate
        ? `Date Prepared: Between ${format(
            new Date(rest.startDate),
            "E MMM d yyyy k:mm:ss z",
          )} to ${format(new Date(rest.endDate), "E MMM d yyyy k:mm:ss z")}`
        : "";
    exData = [
      [company[0]?.CompName],
      ["Income Statement Report"],
      [date],
      [""],
      ["REVENUE"],
      [""],
      /*  [
        "Sales Revenue",
        currency(serviceFeeIncome, {
          symbol: "",
        }).format(),
      ],
      [
        "Service / Fee Income",
        currency(salesRevenue, {
          symbol: "",
        })
          //  .subtract(otherIncome)
          .format(),
      ],
      ["Cost of Sales", costOfgoodsold],
      ["Other Income", otherIncome], */
      ...data.incomeJournal.map((el, i) => [
        el.DetailType,
        el.RunningBalanceCalculated,
      ]),
      ["TOTAL REVENUE", data.incomeJournalTotal],
      [""],
      ["COST OF SALES"],
      ...data.costOfSalesJournal.map((el, i) => [
        el.DetailType,
        el.RunningBalanceCalculated,
      ]),
      ["TOTAL COST OF SALES", data.costOfSalesJournalTotal],
      [""],
      ["Gross Profit", grossProfit],
      [""],
      [""],
      ["Administrative Expenses"],
      ...admins,
      [""],
      ["Total Expenses", administrativeExpensesTotal],
      [""],
      [""],
      ["Net Income", netIncome],
    ];
    //  console.log(exData);
    setExcelData(exData);
  };

  const filterByPeroid = (e) => {
    const selected = e.target;
    if (selected.value === "Date Range") {
      setDisableDate(false);
      setFilterParams({
        ...filterParams,
        month: "",
        startDate: format(new Date(), "yyyy-MM-dd"),
        endDate: format(new Date(), "yyyy-MM-dd"),
        mode: "",
        year: new Date().getFullYear(),
      });
      setDateRangeMode("");
    } else {
      // get the year then get the month and then get the start date and the end date
      const year = filterParams?.year;
      const month = selected?.value;

      let monthDate = "";
      if (year && month) {
        monthDate = getMonthDateRange({ year, month });
      }
      setFilterParams({
        ...filterParams,
        month: selected.value,
        startDate: monthDate ? monthDate.startDate : "",
        endDate: monthDate ? monthDate.endDate : "",

        ...((!selected?.value || selected?.value === "All") && { mode: "" }),
      });
      setDisableDate(true);
      setDateRangeMode("");
    }
  };

  const filterByDateRange = (date) => {
    setFilterParams({
      ...filterParams,
      startDate: format(date[0], "yyyy-MM-dd"),
      endDate: format(date[1], "yyyy-MM-dd"),
      mode: dateRangeMode,
    });
  };
  const filterByDateRangeYearAndMonth = (date) => {
    setFilterParams({
      ...filterParams,
      startDate: format(new Date(date[0]), "yyyy-MM-dd"),
      endDate: format(new Date(date[1]), "yyyy-MM-dd"),
    });
  };

  function getYearBounds(year) {
    const start = moment()
      .year(year)
      .startOf("year"); // Jan 1, 00:00:00.000
    const end = moment()
      .year(year)
      .endOf("year"); // Dec 31, 23:59:59.999
    return { start, end };
  }

  const handleFilterParamsChange = (e) => {
    const { start, end } = getYearBounds(e.target.value);
    if (["mom", "qoq"].includes(filterParams.mode)) {
      setFilterParams({
        ...filterParams,
        [e.target.name]:
          e.target.type === "checkbox" ? e.target.checked : e.target.value,
        startDate: start.format("YYYY-MM-DD"),
        endDate: end.format("YYYY-MM-DD"),
      });
      return;
    } else if (filterParams.mode === "wow") {
      const year = e.target.value;
      const month = filterParams.month;
      let monthDate = "";
      if (year && month) {
        monthDate = getMonthDateRange({ year, month });
      }
      setFilterParams({
        ...filterParams,
        [e.target.name]:
          e.target.type === "checkbox" ? e.target.checked : e.target.value,
        startDate: monthDate ? monthDate.startDate : start.format("YYYY-MM-DD"),
        endDate: monthDate ? monthDate.endDate : end.format("YYYY-MM-DD"),
      });

      return;
    }
    setFilterParams({
      ...filterParams,
      [e.target.name]:
        e.target.type === "checkbox" ? e.target.checked : e.target.value,
    });
  };

  const getNavigationUrl = ({ el, data }) => {
    // if(["mon", "yoy"].includes(filterParams.mode)){

    return el?.Description
      ? `/account-setup/account-list?AccountID=${
          el.AccountID
        }&Description=${encodeURIComponent(el.Description)}&currency=${
          filterParams.currency
        }&convertCurrency=${
          filterParams.convertCurrency
        }&startDate=${data.start || ""}&endDate=${data.end || ""}`
      : `/account-setup/chart-of-account-report?Type=${el.Type}&DetailType=${
          el.DetailType
        }&currency=${filterParams.currency}&convertCurrency=${
          filterParams.convertCurrency
        }&startDate=${data.start || ""}&endDate=${data.end || ""}&subText=${
          el?.subText
        }&AccountID=${el?.AccountID || ""}`;

    // }
    // return el?.Description
    //   ? `/account-setup/account-list?AccountID=${el.AccountID
    //   }&Description=${encodeURIComponent(el.Description)}&currency=${filterParams.currency
    //   }&convertCurrency=${filterParams.convertCurrency
    //   }&startDate=${filterParams.startDate ||
    //   ""}&endDate=${filterParams.endDate || ""}&year=${filterParams.year ||
    //   ""}&month=${filterParams.month || ""}`
    //   : `/account-setup/chart-of-account-report?Type=${el.Type}&DetailType=${el.DetailType
    //   }&currency=${filterParams.currency}&convertCurrency=${filterParams.convertCurrency
    //   }&startDate=${filterParams.startDate ||
    //   ""}&endDate=${filterParams.endDate || ""}&subText=${el?.subText
    //   }&AccountID=${el?.AccountID || ""}`;
  };

  const getNavigationUrlForExpenses = ({ a, data }) => {
    //  if(["mon", "yoy"].includes(filterParams.mode)){
    return `/account-setup/account-list?AccountID=${
      data?.accountIdsForReport?.[a[0]]
    }&Description=${encodeURIComponent(a[0])}&currency=${
      filterParams.currency
    }&convertCurrency=${filterParams.convertCurrency}&startDate=${data.start ||
      ""}&endDate=${data.end || ""}`;

    //  }
    // return `/account-setup/account-list?AccountID=${data?.accountIdsForReport?.[a[0]]
    //   }&Description=${encodeURIComponent(a[0])}&currency=${filterParams.currency
    //   }&convertCurrency=${filterParams.convertCurrency
    //   }&startDate=${filterParams.startDate ||
    //   ""}&endDate=${filterParams.endDate || ""}&year=${filterParams.year ||
    //   ""}&month=${filterParams.month || ""}`;
  };

  const extractTableData = () => {
    if (!tableRef.current) return [];

    const rows = Array.from(tableRef.current.querySelectorAll("tr"));

    return rows.map((row) =>
      Array.from(row.querySelectorAll("th, td")).map((cell) => {
        const text = cell.innerText.trim();
        // Strip currency symbols/commas for numeric-looking cells so Excel treats them as numbers
        const isNumeric = /^[^\d-]*[\d,]+\.?\d*$/.test(text) && text !== "";
        return isNumeric ? text.replace(/[^\d.-]/g, "") : text;
      }),
    );
  };

  const handleExport = () => {
    const data = extractTableData();
    setCsvData(data);
    CSVLinkRef.current.link.click(); // won't have the data yet this way
  };

  function handleComparisonPeriod(selected) {
    setDateRangeMode(selected.value);
    const { start, end } = getYearBounds(filterParams.year);

    const year = filterParams.year;
    const month = filterParams.month;

    const monthDate = getMonthDateRange({ year, month });

    if (selected?.value === "yoy") {
      const { startDate, endDate } = getDefaultThreeYearRange();

      setFilterParams({
        ...filterParams,
        startDate: startDate,
        endDate: endDate,
        mode: selected.value,
      });
    } else if (filterParams?.startDate && filterParams?.endDate) {
      setFilterParams({
        ...filterParams,
        startDate:
          selected.value === "wow" && monthDate
            ? monthDate?.startDate
            : filterParams?.startDate,
        endDate:
          selected.value === "wow" && monthDate
            ? monthDate?.endDate
            : filterParams?.endDate,
        mode: selected.value,
      });
    } else {
      setFilterParams({
        ...filterParams,
        startDate: start.format("YYYY-MM-DD"),
        endDate: end.format("YYYY-MM-DD"),
        mode: selected.value,
      });
    }
  }

  return (
    <IsPrivileged roleName="Financials">
      <IncorrectAccountsData />

      <main className="cash-book">
        <div className="content">
          <header className="pt-5">
            <h1>
              Income Statement
              <button
                title="Refresh"
                onClick={() => refetch()}
                className="btn text-primary"
              >
                <CachedIcon />
              </button>
            </h1>

            <div className="actions gap-3 justify-content-end ">
              <div className="position-relative">
                <label
                  htmlFor="months"
                  className="fw-5 position-absolute bottom-100 start-0 m-1 text-nowrap"
                >
                  Accounting Period:
                </label>

                <select
                  id="months"
                  className="form-select"
                  aria-label="Default select example"
                  onChange={filterByPeroid}
                  value={
                    queryParams?.month === ""
                      ? "Date Range"
                      : queryParams?.month
                  }
                >
                  {months.map((d) => (
                    <option value={d.value}>{d.label}</option>
                  ))}
                </select>
              </div>

              <div className="position-relative">
                {
                  <RsDateRangePicker
                    disabled={disableDate}
                    placement="bottomStart"
                    value={
                      filterParams.startDate && filterParams.endDate
                        ? [
                            parse(
                              filterParams.startDate,
                              "yyyy-MM-dd",
                              new Date(),
                            ),
                            parse(
                              filterParams.endDate,
                              "yyyy-MM-dd",
                              new Date(),
                            ),
                          ]
                        : []
                    }
                    // onClean={() => clearDateRange()}
                    onOk={(date) => filterByDateRange(date)}
                  />
                }
              </div>

              <div className=" position-relative col-2">
                <label
                  htmlFor="comparison_period"
                  className="fw-5 position-absolute bottom-100 start-0 m-1 text-nowrap"
                >
                  Comparison Period:
                </label>
                <Select
                  id="comparison_period"
                  key={monthsOptions}
                  classNamePrefix="form-select"
                  options={monthsOptions}
                  value={monthsOptions.find(
                    (mode) => mode.value === filterParams?.mode,
                  )}
                  onChange={(opt) => handleComparisonPeriod(opt)}
                  menuPortalTarget={document.body}
                  menuPosition="fixed"
                  isSearchable={false}
                />
              </div>

              {filterParams?.mode === "yoy" && (
                <div className=" position-relative col-3">
                  <YearOnYearMonthOnMonthSelector
                    value={[filterParams?.startDate, filterParams?.endDate]}
                    mode={filterParams?.mode}
                    onChange={(value) => filterByDateRangeYearAndMonth(value)}
                  />
                </div>
              )}

              {filterParams?.mode !== "yoy" && (
                <div className="position-relative col-2">
                  <label
                    htmlFor="years"
                    className="fw-5 position-absolute bottom-100 start-0 m-1"
                  >
                    Accounting Year:
                  </label>
                  <input
                    name="year"
                    value={filterParams?.year}
                    onChange={(e) => handleFilterParamsChange(e)}
                    type="number"
                    className="form-control"
                    id="years"
                  />
                </div>
              )}

              <Form.Group className="position-relative">
                <Form.Label className="fw-5 position-absolute bottom-100 start-0 m-1">
                  Filter By
                </Form.Label>
                <Select
                  classNamePrefix="form-select"
                  placeholder="All Currencies"
                  isSearchable={true}
                  options={currenciesOptions}
                  value={currenciesOptions.find(
                    (el) => el.value == filterParams.currency,
                  )}
                  onChange={(selected) =>
                    setFilterParams({
                      ...filterParams,
                      page: 1,
                      currency: selected?.value,
                    })
                  }
                  isClearable={true}
                />
              </Form.Group>
              <Form.Group className="position-relative">
                <Form.Label className="fw-5 position-absolute bottom-100 start-0 m-1">
                  Report In{" "}
                </Form.Label>
                <Select
                  classNamePrefix="form-select"
                  placeholder="Select Currency"
                  isSearchable={true}
                  options={currenciesOptions}
                  value={currenciesOptions.find(
                    (el) => el.value === filterParams.convertCurrency,
                  )}
                  onChange={({ value }) =>
                    setFilterParams({
                      ...filterParams,
                      page: 1,
                      convertCurrency: value,
                    })
                  }
                />
              </Form.Group>
              <CSVLink
                className="btn print d-none"
                filename={`Income Statement Report${
                  queryParams?.consolidate ? " Consolidated " : ""
                }(${format(new Date(), "dd-MMM-yyyy hh:mm:ss a")}).csv`}
                data={csvData}
                ref={CSVLinkRef}
              />
            </div>
          </header>
          <div className="d-flex w-100 gap-3 justify-content-end px-3  align-items-center">
            {/* <Select
              classNamePrefix="form-select"
              options={MODE_OPTIONS}
              value={MODE_OPTIONS.find((m) => m.value === filterParams?.mode) ?? null}
              onChange={(opt) => handleMode(opt.value)}
              menuPortalTarget={document.body}
              menuPosition="fixed"
              isSearchable={false}
            /> */}
            {brachData?.isHq && (
              <Form.Group className="">
                <Form.Check
                  type="switch"
                  label="Consolidate"
                  name="consolidate"
                  className="ga-form-check fs-6"
                  checked={filterParams.consolidate}
                  onChange={(e) => handleFilterParamsChange(e)}
                />
              </Form.Group>
            )}

            {!queryParams?.consolidate && (
              <Dropdown>
                <Dropdown.Toggle
                  variant=""
                  className="btn print"
                  disabled={isfetchingExcel}
                  bsPrefix=""
                >
                  <ExportIcon color="#008000" />
                  Export
                </Dropdown.Toggle>
                <Dropdown.Menu
                  popperConfig={{
                    strategy: "fixed",
                  }}
                  renderOnMount
                  className="text-center"
                >
                  <Dropdown.Item onClick={() => handleExport()}>
                    Excel <ExcelIcon color="#008000" />
                  </Dropdown.Item>

                  {/* <Dropdown.Item as="div">
                    <a
                      target="_blank"
                      rel="noreferrer"
                      href={`${backendUrl}/api/reports/pdf/income-statement?${queryString.stringify(
                        queryParams
                      )}`}
                    >
                      PDF <PDFIcon color="#ff0000" />
                    </a>
                  </Dropdown.Item> */}
                </Dropdown.Menu>
              </Dropdown>
            )}
          </div>

          <div className="px-4 my-4">
            {/* {
              filterParams.mode &&
              <PeriodFilter onChange={handlePeriod} defaultMode={filterParams.mode} queryString={filterParams.dateRanges} handleMode={handleMode} />
            } */}

            {/* REVENUE */}

            {}
            <div style={{ overflowX: "auto" }}>
              <div style={{ minWidth: `${220 + columnCount * 140}px` }}>
                {/* Period header row */}

                <Table className="w-100 " striped ref={tableRef}>
                  <thead>
                    <tr className="fw-bold p-2 bg-low-blue text-white px-5 no-stripe">
                      <th className="text-start  p-3 text-white ">REVENUE</th>

                      {periods.map((p, i) => (
                        <th key={i} className="text-end p-3 text-white ">
                          {getColumnLabel(p)}
                        </th>
                      ))}
                    </tr>
                  </thead>

                  <tbody>
                    {incomeLabels.map((label, i) => (
                      <tr key={i}>
                        <td className="fs-6  px-5 py-1">{label}</td>

                        {periodLookups.map(({ period, incomeMap }, j) => {
                          const el = incomeMap[label];
                          const value = el ? el.RunningBalanceCalculated : 0;

                          return (
                            <td key={j} className="text-end px-3">
                              <Link
                                to={
                                  el
                                    ? getNavigationUrl({
                                        el,
                                        data: period.data,
                                        filterParams,
                                      })
                                    : "#"
                                }
                                className="fs-6 py-1 text-decoration-none text-dark"
                              >
                                {currency(value, {
                                  symbol: getCurrencySymbol(
                                    filterParams.convertCurrency,
                                  ),
                                }).format()}
                              </Link>
                            </td>
                          );
                        })}
                      </tr>
                    ))}

                    {/* TOTAL REVENUE */}
                    <tr className="fw-bold border-top no-stripe">
                      <td className="fs-6 my-2  py-3 px-3 ">TOTAL REVENUE</td>

                      {periods.map((p, i) => (
                        <td key={i} className="fs-6 my-2 text-end py-3 px-3">
                          {currency(p.data?.incomeJournalTotal, {
                            symbol: getCurrencySymbol(
                              filterParams.convertCurrency,
                            ),
                            precision: 2,
                          }).format()}
                        </td>
                      ))}
                    </tr>

                    <tr>
                      <td colSpan={columnCount + 1} />
                    </tr>
                    {/* COST OF SALES */}
                    <tr className="fw-bold p-2 bg-low-blue bg-primary text-white no-stripe">
                      <td className="text-start  py-3 px-3 text-white">
                        {" "}
                        COST OF SALES
                      </td>

                      {periods.map((p, i) => (
                        <td key={i} className="text-end p-3 text-white">
                          {getColumnLabel(p)}
                        </td>
                      ))}
                    </tr>

                    {costOfSalesLabels.map((label, i) => (
                      <tr key={i}>
                        <td className="fs-6 py-1 px-5">{label}</td>

                        {periodLookups.map(({ period, costOfSalesMap }, j) => {
                          const el = costOfSalesMap[label];
                          const value = el ? el.RunningBalanceCalculated : 0;

                          return (
                            <td key={j} className="fs-6 py-1 text-end px-3">
                              <Link
                                to={
                                  el
                                    ? getNavigationUrl({
                                        el,
                                        data: period.data,
                                        filterParams,
                                      })
                                    : "#"
                                }
                                className="text-decoration-none text-dark"
                              >
                                {currency(value, {
                                  symbol: getCurrencySymbol(
                                    filterParams.convertCurrency,
                                  ),
                                }).format()}
                              </Link>
                            </td>
                          );
                        })}
                      </tr>
                    ))}

                    <tr className="fw-bold p-1 mt-0 bg-white border-top no-stripe">
                      <td className="fs-6 my-2  p-3">TOTAL COST OF SALES</td>

                      {periods.map((p, i) => (
                        <td key={i} className="fs-6 my-2 text-end p-3 ">
                          {currency(p.data?.costOfSalesJournalTotal, {
                            symbol: getCurrencySymbol(
                              filterParams.convertCurrency,
                            ),
                            precision: 2,
                          }).format()}
                        </td>
                      ))}
                    </tr>

                    <tr>
                      <td colSpan={columnCount + 1} />
                    </tr>

                    <tr className="fw-bold p-1 mt-3 bg-primary text-white no-stripe">
                      <td className="fs-6 my-2  py-3 px-3 text-white">
                        GROSS PROFIT
                      </td>

                      {periods.map((p, i) => (
                        <td
                          key={i}
                          className="fs-6 my-2 text-end p-3 text-white "
                        >
                          {currency(p.data?.grossProfit, {
                            symbol: getCurrencySymbol(
                              filterParams.convertCurrency,
                            ),
                            precision: 2,
                          }).format()}
                        </td>
                      ))}
                    </tr>

                    {/* OPERATING EXPENSES */}

                    <tr>
                      <td colSpan={columnCount + 1} />
                    </tr>

                    <tr className="fw-bold p-2 mb-2 bg-low-blue text-white no-stripe">
                      <td className="  p-3   text-white">
                        OPERATING EXPENSES (OE, AE)
                      </td>

                      {periods.map((p, i) => (
                        <td key={i} className="text-end p-3  text-white">
                          {getColumnLabel(p)}
                        </td>
                      ))}
                    </tr>

                    {expenseLabels.map((label, i) => (
                      <tr key={i}>
                        <td className="fs-6 py-1 px-5">{label}</td>

                        {periodLookups.map(({ period, expenses }, j) => {
                          const hasValue = label in expenses;
                          const value = hasValue ? expenses[label] : 0;

                          return (
                            <td key={j} className="fs-6 py-1 text-end px-3">
                              <Link
                                to={
                                  hasValue
                                    ? getNavigationUrlForExpenses({
                                        a: [label, value],
                                        data: period.data,
                                        filterParams,
                                      })
                                    : "#"
                                }
                                className="text-decoration-none text-dark"
                              >
                                {currency(value, {
                                  symbol: getCurrencySymbol(
                                    filterParams.convertCurrency,
                                  ),
                                }).format()}
                              </Link>
                            </td>
                          );
                        })}
                      </tr>
                    ))}

                    <tr className="fw-bold p-1 mt-0 bg-white border-top no-stripe">
                      <td className="fs-6  my-2 p-3 ">Total Expenses</td>

                      {periods.map((p, i) => (
                        <td key={i} className="fs-6 my-2 text-end p-3 ">
                          {currency(p.data?.administrativeExpensesTotal, {
                            symbol: getCurrencySymbol(
                              filterParams.convertCurrency,
                            ),
                          }).format()}
                        </td>
                      ))}
                    </tr>

                    {/* NET INCOME */}
                  </tbody>

                  <tfoot>
                    <tr>
                      <td colSpan={columnCount + 1} />
                    </tr>

                    <tr className="fw-bold p-1  bg-primary text-white">
                      <td className="fs-6  p-3 text-white ">NET INCOME</td>

                      {periods.map((p, i) => (
                        <td
                          key={i}
                          className="fs-6 my-2 text-end p-3 text-white "
                        >
                          {currency(p.data?.netIncome, {
                            symbol: getCurrencySymbol(
                              filterParams.convertCurrency,
                            ),
                          }).format()}
                        </td>
                      ))}
                    </tr>
                  </tfoot>
                </Table>
              </div>
            </div>
          </div>
        </div>
        <ModalLoader
          show={isFetching || isfetchingExcel}
          {...(queryParams.consolidate ? { title: "Consolidating..." } : {})}
        />
      </main>
    </IsPrivileged>
  );
}

export default IncomeStateMentWithRange;
